import { cn } from '@/lib/utils';

type BadgeProps = {
  children: React.ReactNode;
  variant: 'levi' | 'yllas' | 'lapland' | 'coming-soon';
};

const variantStyles: Record<string, string> = {
  levi: 'bg-blue-50 text-blue-700 border-blue-200',
  yllas: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  lapland: 'bg-[#9B7B3A]/10 text-[#7A6130] border-[#9B7B3A]/20',
  'coming-soon': 'bg-amber-50 text-amber-700 border-amber-200',
};

export default function Badge({ children, variant }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full border px-2.5 py-0.5',
        'text-[10px] font-semibold uppercase tracking-wider',
        variantStyles[variant]
      )}
    >
      {children}
    </span>
  );
}
